export default "__VITE_ASSET__BU5TCS8I__"